export var newFeaturePopperOptions = {
    '0fe64886-b304-43d9-8ae1-977571a11696': {
        activeUntilDateStr: '2025-09-01',
        placement: 'bottom',
        text: '0fe64886-b304-43d9-8ae1-977571a11696_text',
        buttonText: 'Отлично!'
    },
    '58ac3ce7-58ee-44cf-9db4-d74149cde99c': {
        activeUntilDateStr: '2025-09-01',
        placement: 'right',
        text: 'Попробуйте сообщества!',
        buttonText: 'Ок'
    },
    'f96a6f7e-c12c-4aa1-95a4-bc4069c42d48': {
        activeUntilDateStr: '2025-09-01',
        placement: 'bottom',
        text: 'Нажмите, чтобы узнать больше о сообществах',
        buttonText: 'Отлично, почитаю...'
    },
    'f71445b7-ce1e-4643-87d4-9d231d918c4d': {
        activeUntilDateStr: '2025-09-01',
        placement: 'bottom',
        text: 'Здесь вы можете сразу перейти в чат с администратором.',
        buttonText: 'Здорово!'
    }
};
